export const JSON_ERROR = 'JSON is not valid';
